import Vue from 'vue'
let ApiCall = (api, params, callBack) => {
  // params.apiUserId = Vue.prototype.$apiCallParmas.apiUserId ? Vue.prototype.$apiCallParmas.apiUserId : '';
  // params.buyerUserId = Vue.prototype.$apiCallParmas.buyerUserId ? Vue.prototype.$apiCallParmas.buyerUserId : '';
  Vue.axios({
    data: {
      api: api,
      edatas: params,
    }
  }).then(r => {
    callBack(r)
  }).catch(error => {
    console.log(error)
  });
}
export default ApiCall